"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { Button } from "@/components/ui/button"

export default function NavLink({
  href,
  children,
}: {
  href: string
  children: React.ReactNode
}) {
  const pathname = usePathname()
  const isActive = pathname === href

  return (
    <Button variant="nav" size="sm" asChild>
      <Link
        href={href}
        className="no-underline"
        aria-current={isActive ? "page" : undefined}
      >
        {children}
      </Link>
    </Button>
  )
}
